import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const lang = getLanguageByPath();

export default function LoadFont() {
  const style = document.createElement('style');
  style.innerText = `
  @font-face {
    font-family: 'MiSans-Semibold';
    src: url(${require('./fonts/MiSans-Semibold.woff2')}) format('woff2');
    font-display: swap; /* 关键！避免阻塞渲染 */
  }

  @font-face {
    font-family: 'MiSans-Regular';
    src: url(${require('./fonts/MiSans-Regular.woff2')}) format('woff2');
    font-display: swap; /* 关键！避免阻塞渲染 */
  }

  /* 繁英西葡德法俄 */
  @font-face {
    font-family: 'TWHK';
    src: 
      url(${require('./fonts/SourceHanSansTWHK-Normal.otf')}) format('opentype'),
      url(${require('./fonts/SourceHanSansTWHK-Normal.ttf')}) format('truetype'),
      url(${require('./fonts/SourceHanSansTWHK-Normal.woff2')}) format('woff2')
    ;
    font-weight: normal;
    font-style: normal;
    font-display: swap;
    /* 或者 auto、block、fallback */
  }

  /* 韩 */
  @font-face {
    font-family: 'SansKR';
    src: 
      url(${require('./fonts/SourceHanSansKR-Normal.otf')}) format('opentype'),
      url(${require('./fonts/SourceHanSansKR-Normal.ttf')}) format('truetype'),
      url(${require('./fonts/SourceHanSansKR-Normal.woff2')}) format('woff2')
    ;
    font-weight: normal;
    font-style: normal;
    font-display: swap;
    /* 或者 auto、block、fallback */
  }
  /* 日 */
  @font-face {
    font-family: 'SansJA';
    src: 
      url(${require('./fonts/SourceHanSans-Normal.otf')}) format('opentype'),
      url(${require('./fonts/SourceHanSans-Normal.ttf')}) format('truetype'),
      url(${require('./fonts/SourceHanSans-Normal.woff2')}) format('woff2')
    ;
    font-weight: normal;
    font-style: normal;
    font-display: swap;
    /* 或者 auto、block、fallback */
  }
  `;
  document.head.appendChild(style);
}
